<template>
  <header class="cf-header">
    <div class="cf-header-inner">
      <router-link to="/br-guides" class="cf-logo-link">
        <svg class="cf-logo-icon" viewBox="0 0 109 41" xmlns="http://www.w3.org/2000/svg" aria-label="Cloudflare logo">
          <path d="M81.8 18.6c-.2-.1-.5-.1-.7-.1-1.2 0-2.3.5-3.1 1.3-.8-2.4-3-4.1-5.6-4.1-1.4 0-2.7.5-3.7 1.3-.9-3.5-4-6-7.8-6-4.5 0-8.1 3.6-8.1 8.1 0 .2 0 .4.01.6H52.7c-3 0-5.5 2.5-5.5 5.5s2.5 5.5 5.5 5.5h29.1c2.8 0 5-2.2 5-5 0-2.6-1.9-4.7-4.5-5.1" fill="#F6821F"/>
          <path d="M89.4 20.7c-.1 0-.3 0-.4.01-1 0-1.9.4-2.6 1.1-.7-2-2.5-3.4-4.7-3.4-1.2 0-2.2.4-3.1 1.1-.8-2.9-3.4-5-6.5-5-3.8 0-6.8 3-6.8 6.8 0 .2 0 .3.01.5h-.1c-2.5 0-4.6 2.1-4.6 4.6s2.1 4.6 4.6 4.6H89.4c2.3 0 4.2-1.9 4.2-4.2 0-2.3-1.8-4.1-4.2-4.1" fill="#FBAD41"/>
        </svg>
        <span class="cf-logo-text">browser-rendering</span>
      </router-link>

      <nav class="cf-nav">
        <a
          class="cf-nav-link"
          href="https://developers.cloudflare.com/browser-rendering/"
          target="_blank"
          rel="noopener"
        >Developer Docs</a>
        <a
          class="cf-nav-btn"
          href="https://dash.cloudflare.com/"
          target="_blank"
          rel="noopener"
        >Dashboard →</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'BrHeader'
}
</script>

<style scoped>
.cf-header {
  background: #FFFFFF;
  border-bottom: 1px solid #E4E4E0;
  position: sticky;
  top: 0;
  z-index: 100;
}

.cf-header-inner {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 1.5rem;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cf-logo-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.cf-logo-icon {
  width: 88px;
  height: 32px;
  flex-shrink: 0;
}

.cf-logo-text {
  font-size: 15px;
  font-weight: 600;
  color: #1D1D1D;
  letter-spacing: -0.01em;
}

.cf-nav {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.cf-nav-link {
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  text-decoration: none;
  transition: color 0.15s;
}
.cf-nav-link:hover { color: #1D1D1D; }

.cf-nav-btn {
  font-size: 14px;
  font-weight: 600;
  color: #FFFFFF;
  background: #F6821F;
  text-decoration: none;
  padding: 0.4rem 1rem;
  border-radius: 6px;
  transition: background 0.15s;
}
.cf-nav-btn:hover { background: #E07315; color: #FFFFFF; }

@media (max-width: 600px) {
  .cf-logo-text { display: none; }
  .cf-nav-link { display: none; }
}
</style>